import { Box, Typography } from '@mui/material';
import styles from './taskBoard.module.scss';
import classNames from 'classnames/bind';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { BaseBoard } from '~/components/common';
import { ColumnType, ItemChangeProps } from '~/components/common/base-board/BaseBoard';
import { handleApiError, notify } from '~/utils/helper';
import { PERMISSIONS } from '~/utils/constants/permission';
import usePermission from '~/hooks/usePermission';
import TaskCard from './TaskCard';
import { useTranslation } from 'react-i18next';
import { handleUpdateTask } from '~/thunks/task/taskThunk';

const cx = classNames.bind(styles);

const TaskBoard = () => {
  const permission = usePermission();
  const { taskBoard } = useAppSelector((state) => state.task);
  const dispatch = useAppDispatch();
  const { t } = useTranslation('admin/job');
  const renderColumnComponent = (data: ColumnType) => {
    return (
      <Typography
        variant='h6'
        gutterBottom
        className={cx('container-tittle')}
        style={{
          color: data.color,
          backgroundColor: data.backgroundColor,
        }}
      >
        {data.name}
      </Typography>
    );
  };

  const handleItemChange = async (item: ItemChangeProps) => {
    try {
      await dispatch(
        handleUpdateTask({
          id: item.itemId,
          data: {
            position: Number(item.itemPosition),
            statusId: Number(item.columnId),
          },
        })
      ).unwrap();
      notify('success', t('editSuccess', { ns: 'admin/common' }));
    } catch (e: any) {
      handleApiError(e);
    }
  };

  return (
    <Box className={cx('JobBoardContainer')}>
      <BaseBoard
        data={taskBoard}
        renderColumn={renderColumnComponent}
        renderItem={(item: any, column: any) => {
          return <TaskCard task={item} column={column} />;
        }}
        onItemChange={handleItemChange}
        columnClassName={'h-[calc(100vh-350px)]'}
        disabled={!permission[PERMISSIONS.projectTask_view]}
      />
    </Box>
  );
};

export default TaskBoard;
